import Inquiry from "./Inquiry";

const Contact = () => {
  return (
    <div
      id="contact"
      className="relative w-full h-full mx-auto px-[calc((100%-var(--container))/2)] py-14 lg:py-28 xl:py-36"
    >
      {/* Heading */}
      <div className="text-center">
        <p className="md:text-lg lg:text-xl">365일 24시간 언제든지 상담 가능합니다</p>
        <h2 className="mt-2 text-2xl md:text-4xl xl:text-5xl">
          <span className="font-light">바우하우스</span> <span className="text-[#F4791C]">상세견적문의</span>
        </h2>
      </div>

      <div
        data-aos="fade-up"
        className="mt-8 relative w-full h-fit  max-w-[1100px] mx-auto py-8 px-5 border-4 border-primary rounded-2xl"
      >
        <Inquiry />
      </div>
    </div>
  );
};

export default Contact;
